<ng-template [ngIf]="isModificandoVincolo">
  <app-loading></app-loading>
</ng-template>
<div class="d-flex mt-1 ">
  <form [formGroup]="modificaVincoloForm">
    <div class="grid formgrid p-fluid ">
      <div class="field col-7">
        <label for="tipo" class="font-bold">TIPO </label>
        <p-dropdown inputId="tipo" [options]="listeService.tipologieVincolo" [showClear]="true"
            placeholder="Scegli il tipo di vincolo" formControlName="tipo" 
            [appendTo]="'body'">
            <ng-template let-tipo pTemplate="item">
                <div class="flex align-items-center">
                    <p-tag
                    [value]="tipo.label | uppercase"
                    [style]="{
                     'background-color': stiliService.getColoreCategoriaVincoloKO(tipo.value) ,
                     'color': '#FFFFFF' ,
                    'border-radius': '6px',
                    'padding': '.25em .25rem',
                    'font-weight': '700',
                    'font-size': '11px',
                    'letter-spacing': '.3px;',
                    'cursor': 'pointer',
                    }"
                    
                    class="mr-1">
                </p-tag>
                </div> 
            </ng-template>
        </p-dropdown>
      </div>
      <div class="field col-5">
        <label for="tipo" class="font-bold">CATEGORIA</label>
        <p-dropdown inputId="tipo" [options]="categorieVincoloFiltrate" [showClear]="true"
            placeholder="Scegli la categoria di vincolo" formControlName="categoria" 
            [appendTo]="'body'">
            <ng-template let-categoria pTemplate="item">
                <div class="flex align-items-center">
                    <p-tag
                    [value]="categoria.codice + ' - ' + categoria.label | uppercase"
                    [style]="{
                     'background-color': stiliService.getColoreCategoriaVincoloKO(categoria.tipologiaVincolo.id) ,
                     'color': '#FFFFFF' ,
                    'border-radius': '6px',
                    'padding': '.25em .25rem',
                    'font-weight': '700',
                    'font-size': '11px',
                    'letter-spacing': '.3px;',
                    'cursor': 'pointer',
                    }"
                    
                    class="mr-1">
                </p-tag>
                </div>
            </ng-template>
        </p-dropdown>
      </div>
      <!-- <div class="field col">
        <label for="categoria" >Causa KO</label>
        <p-dropdown inputId="categoria" [options]="listeService.categorieKOPF" [showClear]="true"
            placeholder="Scegli la causa del KO" formControlName="categoria">
            <ng-template let-categoria pTemplate="item">
                <div class="flex align-items-center">
                    <p-tag
                    [value]="categoria.label | uppercase"
                    [style]="{
                     'background-color': stiliService.getCategoriaKOPFColor(categoria.label) ,
                     'color': '#FFFFFF' ,
                    'border-radius': '6px',
                    'padding': '.25em .25rem',
                    'font-weight': '700',
                    'font-size': '11px',
                    'letter-spacing': '.3px;',
                    'cursor': 'pointer',
                    }"
                    class="mr-1">
                </p-tag>
                </div>
            </ng-template>
        </p-dropdown>
      </div> -->
     <!--  <div class="field mt-2 mb-2 col-12">
        <label for="note" class="font-small text-900 text-blue-900">Note</label>
        <span class="p-input-icon-left">
          <i class="pi pi-info-circle"></i>
          <textarea id="note" rows="5" [autoResize]="true" formControlName="note" pInputTextarea></textarea>
      </span>
    </div> -->
   </div>
</form>
</div>
  <div class="margin-top-1" style="text-align: center; display: flex; justify-content: center; align-items: center;">
    <p-button icon="pi pi-times" (onClick)="conferma(false)" label="Annulla" class="p-button-text mr-2"
    styleClass="p-button-warning"></p-button>
   <p-button  icon="pi pi-check" label="Conferma"
    class="p-button-text ml-100" styleClass="p-button-success" (click)="conferma(true)" [disabled]="isModificandoVincolo || !modificaVincoloForm.valid"></p-button>
</div>

